import {format} from "date-fns";
import {DatesPeriodType} from "../types";

export const getDates = (period: DatesPeriodType): string[] => {
  if (!period || !period.interval.length) return [];

  return period.interval.map(date => format(date, 'yyyy-MM-dd'));
}